import React from 'react';
import clone from 'clone';
import url from '../../urlhandler/urlHandlerActions';
import { findIndex } from 'underscore';

class TopBarBlock extends React.Component {
    constructor(props) {
      super(props);
      this.handleSortBy = this.handleSortBy.bind(this);
      this.handleSortingData = this.handleSortingData.bind(this);
      this.deleteSearch = this.deleteSearch.bind(this);

      this.state = {
        option: {
          sortBy: 'asc',
        },
      };
    }
    componentWillMount() {
     // this.processData();
    }
    componentWillReceiveProps() {
      this.processData();
    }
    processData() {
      const allLayout = clone(this.props.allLayout);
      const isSearch = findIndex(allLayout, { type: 'search' });
      if (isSearch !== -1) {
        const searchAttr = clone(allLayout[isSearch].searchAttr);
        window.searchArray.map((searchItem) => {
          const isTaxonomy = findIndex(searchAttr, { selectedTaxonomy: searchItem.key });
          const isMetakey = findIndex(searchAttr, { selectedMetakey: searchItem.key });
          if (isTaxonomy !== -1) {
            searchItem.selectedDataType = searchAttr[isTaxonomy].selectedDataType;
            searchItem.viewType = searchAttr[isTaxonomy].viewType;
            searchItem.title = searchAttr[isTaxonomy].title;
            if (searchItem.viewType === 'combobox') {
              searchItem.linearData = this.props.helperData.terms[searchItem.key].linear;
            }
          } else if (isMetakey !== -1 && searchItem.key.search('[min]') === -1 && searchItem.key.search('[start]')) {
            searchItem.selectedDataType = searchAttr[isMetakey].selectedDataType;
            searchItem.viewType = searchAttr[isMetakey].viewType;
            searchItem.title = searchAttr[isMetakey].title;
            searchItem.metakey = searchAttr[isMetakey].selectedMetakey;
          } else {
            // will work for range and daterange
            const key = 'key';
            const isDateRangeStart = searchItem[key].indexOf('[start]');
            const isDateRangeEnd = searchItem[key].indexOf('[end]');
            const isRangeMin = searchItem[key].indexOf('[min]');
            const isRangeMax = searchItem[key].indexOf('[max]');
            if (isDateRangeStart !== -1) {
              const dateStartMetakey = searchItem[key].split('[start]').length ? searchItem[key].split('[start]')[0] : null;
              const index = findIndex(searchAttr, { selectedMetakey: dateStartMetakey });
              searchItem.selectedDataType = searchAttr[index].selectedDataType;
              searchItem.viewType = searchAttr[index].viewType;
              searchItem.title = searchAttr[index].title;
              searchItem.metakey = dateStartMetakey;
              searchItem.key = searchItem[key];
              this.startDateRange = searchItem.value;
            } else if (isDateRangeEnd !== -1) {
              const dateEndmetakey = searchItem[key].split('[end]').length ? searchItem[key].split('[end]')[0] : null;
              const index = findIndex(searchAttr, { selectedMetakey: dateEndmetakey });
              searchItem.selectedDataType = searchAttr[index].selectedDataType;
              searchItem.viewType = searchAttr[index].viewType;
              searchItem.title = searchAttr[index].title;
              searchItem.metakey = dateEndmetakey;
              searchItem.key = searchItem[key];
              this.endDateRange = searchItem.value;
            } else if (isRangeMin !== -1) {
              const rangeMinMetakey = searchItem[key].split('[min]').length === 2 && searchItem[key].split('[min]')[0].length !== 0 ? searchItem[key].split('[min]')[0] : null;
              const indexforRangeMin = findIndex(searchAttr, { selectedMetakey: rangeMinMetakey });
              searchItem.selectedDataType = searchAttr[indexforRangeMin].selectedDataType;
              searchItem.viewType = searchAttr[indexforRangeMin].viewType;
              searchItem.title = searchAttr[indexforRangeMin].title;
              searchItem.metakey = rangeMinMetakey;
              searchItem.key = searchItem[key];
              this.minRangeValue = searchItem.value;
            } else if (isRangeMax !== -1) {
              const rangeMaxMetakey = searchItem[key].split('[max]').length ? searchItem[key].split('[max]')[0] : null;
              const indexRangeMin = findIndex(searchAttr, { selectedMetakey: rangeMaxMetakey });
              searchItem.selectedDataType = searchAttr[indexRangeMin].selectedDataType;
              searchItem.viewType = searchAttr[indexRangeMin].viewType;
              searchItem.title = searchAttr[indexRangeMin].title;
              searchItem.metakey = rangeMaxMetakey;
              searchItem.key = searchItem[key];
              this.maxRangeValue = searchItem.value;
            }
          }
        });
      }
    }

    deleteSearch(index, item) {
      url.push({
        'searchType': 'globalSearch',
        'searchField': 'searchAttrTopBar',
        'value': item.value,
        'key': item.key,
        'rangeKey': item.metakey,
        'viewType': item.viewType,
        'linearData': item.linearData,
        index,
      });
    }

    handleSortingData(data) {
      const { option } = this.state;
      option.sortAttr = data;
      this.setState({ option });
      this.props.onListenTopBlock(option);
    }

    handleSortBy(type) {
      const { option } = this.state;
      option.sortBy = type;
      this.setState({ option });
      if ('sortAttr' in option) {
        this.props.onListenTopBlock(option);
      }
    }

    render() {
      const { settingsData } = this.props;
      let topbar;
      if ('topbar' in this.props.block) {
        topbar = this.props.block.topbar;
      } else {
        topbar = {
          topbar: false,
          filter: false,
          sorting: false,
          viewchanger: false,
          topbarpagination: false,
        };
      }

      let sortingData = [];
      if ('sorting' in this.props.block) {
        sortingData = this.props.block.sorting;
      }

      const index = findIndex(window.searchArray, { key: 'pagenumber' });
      let flag = null;
      if (index !== -1) {
        flag = window.searchArray.length !== 1 ? false : true;
      } else {
        flag = window.searchArray.length !== 1 ? false : true;
      }
      const ThemeComponent = window.ReactiveTheme[settingsData.theme] ? window.ReactiveTheme[settingsData.theme].bar : '';
      return (
        <div>
          {topbar.topbar === 'true' && <div className="reactive-top-bar">
            { topbar.viewchanger === 'true' ||  topbar.sorting === 'true' ?
              <div className="view-sorting-option">
                { topbar.viewchanger === 'true' && <ThemeComponent.viewChanger allLayout={this.props.allLayout}/> }
                { topbar.sorting === 'true' && <ThemeComponent.sorting sortingData={sortingData} handleSortBy={this.handleSortBy} handleSortingAttribute={this.handleSortingData} /> }
              </div> : null
            }
            <div>
              { topbar.filter === 'true' && <ThemeComponent.searchAttributeShow {...this.props} flag={flag} deleteSearchAttr={this.deleteSearch} /> }
            </div>
          </div> }

        </div>
      );
    }
}

TopBarBlock.propTypes = {
  'searchAttr': React.PropTypes.array,
  'allLayout': React.PropTypes.array,
  'shortcodeKey': React.PropTypes.number,
  'uid': React.PropTypes.string,
  'block': React.PropTypes.object,
  'helperData': React.PropTypes.object,
  'barData': React.PropTypes.object,
  'results': React.PropTypes.number,
  'onListenTopBlock': React.PropTypes.func,
  flag: React.PropTypes.node,
};

export default TopBarBlock;



// WEBPACK FOOTER //
// ./assets/src/frontend/preview/block/topbarBlock.js